import React, { useState, useEffect, useContext } from "react";

//Material ui core
import {
  Drawer,
  List,
  Typography,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
//Material ui icons
import { MenuOpen, GroupWork, People } from "@material-ui/icons";
import { listItems } from "../../Util/DrawerUtils/index";
//React-router-dom
import { withRouter } from "react-router-dom";
import clsx from "clsx";
import { RouteContext } from "../../Context/RouteContext";
import { RestaurantContext } from "../../Context/RestaurantData";
const DrawerComp = (props) => {
  const { setRoute } = useContext(RouteContext);
  const { restaurantData } = useContext(RestaurantContext);
  const [listItem, setListItem] = useState([...listItems]);
  useEffect(() => {
    if (localStorage.getItem("COgnitoRole")!="RestAdmin" && restaurantData) {
      
      const permissions =
        restaurantData?.groups?.[JSON.parse(localStorage.getItem("COgnitoRole")).filter((restid)=> {return restid.restId===restaurantData.id})[0].role]
          ?.permissions || {};
      const noAccessKeys = Object.keys(permissions).filter(
        (key) => permissions[key] === "NO_ACCESS"
      );
      let permissionList = listItem;
      for (let i = permissionList.length - 1; i >= 0; i--) {
        console.log("keyes " + i, permissions);
        if (noAccessKeys.includes(permissionList[i].detect)) {
          permissionList.splice(i, 1);
        }
      }
      setListItem(permissionList);
    }
  }, [restaurantData]);
  useEffect(() => {
    if (localStorage.getItem("COgnitoRole") === null) {
      window.location.reload();
    }
    if (
      localStorage.getItem("COgnitoRole") === "RestAdmin" ||
      localStorage.getItem("COgnitoRole") === "Admin"
    ) {
      setListItem((prev) => {
        return [
          ...prev,
          {
            pageURL: "/groups",
            text: "Roles",
            Icon: GroupWork,
          },
          {
            pageURL: "/Employees",
            text: "Employees",
            Icon: People,
          },
        ];
      });
    }
  }, []);
  const {
    history,
    location,
    classes,
    open,
    handleDrawerClose,
    isMobile,
    activationStatus,
  } = props;

  let activeLinkArray = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];

  const [activeArray, setActiveArray] = useState(activeLinkArray);
  useEffect(() => {
    let activeLinkArrayClone = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
    let pageUrlArr = listItem.map((item) => item.pageURL);
    let activeIndex = pageUrlArr.findIndex(
      (item) => item === location.pathname
    );
    activeLinkArrayClone[activeIndex] = true;
    setActiveArray(activeLinkArrayClone);
  }, [location.pathname]);

  const handleClick = (pageURL, index) => {
    let activeItemArr = [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ];
    setActiveArray(activeItemArr);
    activeItemArr[index] = true;
    setActiveArray(activeItemArr);
    setRoute(pageURL);
    history.push(pageURL);
    if (isMobile) {
      handleDrawerClose();
    } else {
      return;
    }
  };

  return (
    <div>
      <Drawer
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        variant="permanent"
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        elevation={0}
      >
        <div
          className={clsx(
            classes.drawerHeader,
            !activationStatus && classes.mt20
          )}
        >
          {open && (
            <Typography
              variant="h4"
              noWrap
              color="primary"
              className={clsx(classes.brandStylesII)}
              align="left"
            >
              Insmeal
            </Typography>
          )}
          <IconButton onClick={handleDrawerClose}>
            <MenuOpen color="primary" />
          </IconButton>
        </div>
        <List>
          {listItem.map((item, index) =>
            open ? (
              <ListItem
                button
                onClick={() => handleClick(item.pageURL, index)}
                key={item.text}
              >
                <ListItemIcon
                  className={
                    activeArray[index] ? classes.active : classes.inactive
                  }
                >
                  <item.Icon />
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  className={
                    activeArray[index] ? classes.active : classes.inactive
                  }
                />
              </ListItem>
            ) : (
              <Tooltip
                title={item.text}
                key={item.text}
                arrow
                placement="right"
              >
                <ListItem
                  button
                  onClick={() => handleClick(item.pageURL, index)}
                  key={item.text}
                >
                  <ListItemIcon
                    className={
                      activeArray[index] ? classes.active : classes.inactive
                    }
                  >
                    <item.Icon />
                  </ListItemIcon>
                </ListItem>
              </Tooltip>
            )
          )}
        </List>
      </Drawer>
    </div>
  );
};

export default withRouter(DrawerComp);
